export default "__VITE_ASSET__123b3d2f__"